@if (widgets()) {
<div class="dashboard-grid">
	@for (widget of widgets(); track widget.type) {
	<dsy-card class="dashboard-card" card-color="#fff" height="auto" is-round-border="true" no-padding="true" [class.dashboard-card--small]="widget.size === 'SMALL'"
		[class.dashboard-card--medium]="widget.size === 'MEDIUM'" [class.dashboard-card--large]="widget.size === 'LARGE'">
		<ng-container *ngComponentOutlet="resolveComponent(widget.__typename); inputs:{widget}"></ng-container>
	</dsy-card>
	}
</div>
} @else {
<div class="loading-spinner">
	<dsy-loader type="spinner" size="xx-small" animation-speed="slow"></dsy-loader>
</div>
}